import type { CardActionResult } from './types';

/**
 * Whether a card reply should start streaming a crew run: only for a `start`
 * that carries a run id, and never after New chat, a record change or unmount
 * aborted the turn's controller while the POST was in flight.
 */
export function shouldStartCrew(
  signal: AbortSignal,
  reply: Pick<CardActionResult, 'action' | 'runId'>,
): string | null {
  if (signal.aborted) return null;
  return reply.action === 'start' && reply.runId ? reply.runId : null;
}
